import { render, staticRenderFns } from "./BetaTestersInput.vue?vue&type=template&id=c3f4ba5a"
import script from "./BetaTestersInput.vue?vue&type=script&lang=js"
export * from "./BetaTestersInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports